export default {
    appTitle: 'Web de prestadores',
    title: 'Autorizações',
    filterLabel: 'Filtrar por',
    orderLabel: 'Ordenar por',
    authorizationTabLabel: 'Autorizações',
    loadingDataLabel: 'Obtenção de autorizações',
    emptyDataLabel: 'Nenhum resultado encontrado',
    tryAgainLabel: 'Tente pesquisar outro termo ou ',
    paginationSizeLabel: 'Resultados/página',
    addAuthorization: 'Nova autorização',
    addAuthorizationShortLabel: 'Novo',
    resultLabel: '{result} resultado | {result} resultados',
    lastUpdateLabel: 'Atualização mais recente: {datetime}',
    cleanFilters: 'limpar os filtros',
    filtersAppliedLabel: ' aplicados',
    documentation: {
        complete: 'Completo',
        incomplete: '({uploaded}/{total}) Documentos'
    },
    createAuthorization: {
        success: 'A autorização foi criada com sucesso.',
        error: 'Ocorreu um erro ao criar a autorização.'
    },
    filters: {
        status: 'Status',
        from: 'De',
        to: 'Até',
        dateRange: 'Intervalo de datas',
        searchCode: 'Pesquisar autorização ou protocolo',
        satisfiesDocumentsPolicy: 'Documentação'
    },
    order: {
        createdAt: 'Data de criação',
        beneficiaryName: 'Nome do benificiário (a-z)',
        coverageType: 'Cobertura (a-z)',
        status: 'Status'
    },
    authorizationGrid: {
        claimId: 'Protocolo',
        authorizationCode: 'Autorização',
        code: 'ID de autorização',
        createdAt: 'Data de criação',
        sponsor: 'Convênio',
        beneficiary: 'Beneficiário',
        memberCode: 'Cardeirinha',
        authorizationType: 'Tipo de autorização',
        documentation: 'Documentação',
        status: 'Status',
        providerBranchName: 'Filial'
    },
    status: {
        error: {
            title: 'Erro',
            description: 'Algo deu errado na autorização'
        },
        paid: {
            title: 'Pago',
            description: 'Autorização paga'
        },
        voided: {
            title: 'Desabilitado',
            description: 'Autorização cancelada'
        },
        expired: {
            title: 'Expirado',
            description: 'A validade da autorização expirou'
        },
        canceled: {
            title: 'Cancelado',
            description: 'Autorização cancelada'
        },
        completed: {
            title: 'Preenchido',
            description: 'Autorização concluída com sucesso'
        },
        inProgress: {
            title: 'Em andamento',
            description: 'Os processos para a conclusão da autorização estão em andamento'
        },
        failed: {
            title: 'Falha',
            description: 'A autorização não pôde ser realizada'
        },
        ready: {
            title: 'Concluído',
            description: 'A autorização foi realizada corretamente'
        },
        expirationInProgress: {
            title: 'Expiração em processo',
            description: 'Os processos para expirar a autorização estão em andamento'
        },
        updateInProgress: {
            title: 'Atualização em processo',
            description: 'Os processos para a atualização da autorização estão em andamento'
        }
    },
    statusDescription: {
        title: 'Filtrar por status',
        apply: 'Aplicar'
    },
    types: {
        pharmacy: 'Farmácia',
        process: 'Procedimento',
        prescriptionDrugs: 'Medicamentos',
        diagnosticTest: 'Testes de diagnóstico',
        sports: 'Esportes',
        wellness: 'despesas médicas',
        education: 'Educação',
        creditCardBalance: 'Saldo devedor',
        occupationalHazard: 'Risco ocupacional'
    },
    tabs: {
        authorizations: 'Autorizações',
        NewAuthorization: 'Nova autorização',
        settlements: 'Protocolos',
        newSettlement: 'Novo protocolo'
    },
    actions: {
        void: 'Cancelar',
        voidOnlyClaim: 'Cancelar protocolo'
    },
    satisfiesDocumentsPolicy: {
        complete: 'Completa',
        incomplete: 'Incompleta'
    }
}